module.exports = __webpack_public_path__ + "static/media/Share picture@2x.f2b65563.png";